import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from "react-router"
import { getBusinessRules } from '../../../actions/BusinessRulesAction'
import { TriggerHelper, TriggerEvents } from './TriggerHelper'
import { ConditionHelper } from './ConditionHelper'
import Utils from '../../../services/Utils';
import { ActionsEnum } from '../../../constants/Enums/BusinessRulesEnum'
import { LocalStorageService } from "../../../services/LocalStorageService"
import { showCustomPopup } from '../../../actions/PopupAction';
import { Browser } from '../../../services/helpers/Browser';
import { LanguageService } from '../../../services/LanguageService'
import { popupHashes } from '../PopupEnum';
import SiteEvent from '../../../services/events/SiteEvent';
const PeriodTypeEnum = {
  Hour: 1,
  Day: 2,
  Month: 3,
  Week: 4
}


/**
 * BusinessRules Handler component
 * Recives data checks conditinons of triggers then fires actions
 * 
 * @extends React.Component
 */

const BusinessRules = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const unlisten = useRef();
  const languages = useSelector(state => state.settings.languages);
  const { data } = useSelector(state => state.businessRules);


  useEffect(() => {
    languages.length && !data && dispatch(getBusinessRules()).then((result) => {
      if (result) {
        clearRulesFromStorage(result);
        triggersMap(result)
      }
    }).finally(() => {
      !checkTriggerStorage() && TriggerHelper.triggerEvent(TriggerEvents.enterWebsite);
      let prevLocation = history.location;
      unlisten.current = history.listen((location, action) => {
        const checkLocatin = (location, prevLocation) => {
          return (((!location.pathname.includes('/popup/') && !prevLocation.pathname.includes('/popup/')) ||
            location.pathname.includes('/popup/') && Object.keys(popupHashes).filter((i) => location.pathname.includes(popupHashes[i].val) && popupHashes[i].auth).length)
            && location.pathname !== prevLocation.pathname && action === "PUSH")
        }

        if (location.pathname !== prevLocation.pathname) {
          SiteEvent.dispatchRouteChangeEvent(location, prevLocation);
        }

        checkLocatin(location, prevLocation) && TriggerHelper.triggerEvent(TriggerEvents.pageOpen);


        prevLocation = location;

      })
    });



  }, [languages])

  useEffect(() => {

    return () => { unlisten.current && unlisten.current() }
  }, [])



  /** This function checks LocalStorage for stored triggers   
   * @function
   * 
   * @memberOf BusinessRules
   * 
   *  @returns {boolean} 
   */
  const checkTriggerStorage = () => {
    const storageData = LocalStorageService.get(`businessRulesTrigger`);
    if (storageData) {
      if (storageData[TriggerEvents.logout]) {
        TriggerHelper.triggerEvent(TriggerEvents.logout);
        Object.keys(storageData).length > 1 ? (LocalStorageService.set(`businessRulesTrigger`, (() => { delete storageData[TriggerEvents.logout]; return storageData })())) : LocalStorageService.remove('businessRulesTrigger')
        return true;
      }
    }
    return false;
  }
  /** This function Maps over stored Busines Rules and removes inactive rules 
   * @function
   * * @param {Object} data  business rule data
   * @memberOf BusinessRules
   */
  const clearRulesFromStorage = (data) => {
    const activeIds = data.map((i) => (`${i.ruleId}`))
    const storageData = LocalStorageService.get(`businessRules`);
    if (storageData) {
      Object.keys(storageData).forEach(id => {
        if (!activeIds.includes(id)) {
          delete storageData[id]
        }
      })
      Object.keys(storageData).length ? LocalStorageService.set(`businessRules`, storageData) : LocalStorageService.remove(`businessRules`);
    }

  }

  /** This function compares storage rule data with actual data then clears LoaclStorage
   * @function
   * @memberOf BusinessRules
   */
  const triggersMap = (data) => {

    for (let i = 0; i < data.length; i++) {
      TriggerHelper.triggersHandler(data[i], ConditionHelper.conditionsMap, actionsMap)
    }

  }

  /** This function Maps over actions  calls actionsHandler for each action
   * @function
   * @param {Object} data  trigger data
  */
  const actionsMap = (data) => {
    const { actions = [], conditions, ...rest } = data
    for (let i = 0; i < actions.length; i++) {
      actionsHandler(actions[i], rest)
    }
  }

  /** This function Handles   actions  types logic
      * @function
      * @param {Object} action   action 
      * @param {Object} ruleData   bussines rule data 
      */
  const actionsHandler = (action, ruleData) => {

    switch (action.name) {
      case ActionsEnum.ShowPopupAction:
        const storageData = LocalStorageService.get(`businessRules`);
        let periodSeconds = 0;
        switch (+action.values.period) {
          case PeriodTypeEnum.Hour:
            periodSeconds = 60 * 60
            break;
          case PeriodTypeEnum.Day:
            periodSeconds = 24 * 60 * 60
            break;
          case PeriodTypeEnum.Week:
            periodSeconds = 7 * 24 * 60 * 60
            break;
          case PeriodTypeEnum.Month:
            periodSeconds = 30 * 24 * 60 * 60
            break;
          default:
            break;
        }
        if (storageData && storageData[ruleData.ruleId] && isActionValid(storageData[ruleData.ruleId], action.values)) {
          if (+storageData[ruleData.ruleId].count < +action.values.maxCount) {
            let data = {
              ...storageData,
              [ruleData.ruleId]: {
                name: action.name,
                ruleId: ruleData.ruleId,
                maxCount: action.values.maxCount,
                count: ++storageData[ruleData.ruleId].count,
                period: action.values.period,
                delay: action.values.delay,
                ttl: storageData[ruleData.ruleId].ttl
              }

            }
            executeAction(action, data)
          }
        } else {

          let data = {
            ...storageData,
            [ruleData.ruleId]: {
              name: action.name,
              ruleId: ruleData.ruleId,
              count: 1,
              period: action.values.period,
              maxCount: action.values.maxCount,
              delay: action.values.delay,
              ttl: Date.now() + periodSeconds * 1e3
            }
          }
          executeAction(action, data)
        }
        break;
      case ActionsEnum.NavigateToAction:
        executeAction(action)
        break;
      default:
        break;

    }
  }
  /** This function checkes busines rule    
       * @function
       * @param {Object} storageData  data retrived from storage
       * @param {Object} data  action values 
       */
  const isActionValid = (storageData, data) => {
    if (storageData.period === data.period && storageData.maxCount === data.maxCount && Date.now() < storageData.ttl) {
      return true
    }
    return false
  }
  /** This function executes busines rule action    
        * @function
        * @param {Object} action  action value
        * @param {Object} data  data retrived from storage
        */
  const executeAction = (action, data) => {
    switch (action.name) {
      case ActionsEnum.ShowPopupAction:
        let delay = action?.values?.delay ? +action.values.delay * 1e3 : 0
        setTimeout(() => {
          if (!Utils.isPreviewMode() && action.values.popupList) {
            dispatch(showCustomPopup(action.values.popupList))
            LocalStorageService.set(`businessRules`, data)
          }
        }, delay)

        break;
      case ActionsEnum.NavigateToAction:
        setTimeout(() => {
          const isLngInPath = (path, language) => (path.indexOf('/' + language + '/') > -1 || path === '/' + language)
          if (Utils.checkAbsolutePath(action.values.url)) {
            if (action.values.url.includes(Browser.getDomain())) {
              let splitUrlArr = action.values.url.split(Browser.getDomain())
              history.push(splitUrlArr[splitUrlArr.length - 1])
            } else {
              window.location.href = Utils.fixAbsoluteUrl(action.values.url);
            }
          } else {
            history.push(isLngInPath(action.values.url, LanguageService.getSelectedLanguage()) ? action.values.url : `/${LanguageService.getSelectedLanguage()}${action.values.url}`);
          }
        }, 0)

        break;
      default:
        break;
    }
  }
  return (
    <></>
  )

}

export default BusinessRules;
